import { render, staticRenderFns } from "./shopAttachmentSet.vue?vue&type=template&id=47ce366d&scoped=true&"
import script from "./shopAttachmentSet.vue?vue&type=script&lang=js&"
export * from "./shopAttachmentSet.vue?vue&type=script&lang=js&"
import style0 from "./shopAttachmentSet.vue?vue&type=style&index=0&id=47ce366d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce366d",
  null
  
)

export default component.exports